<template>
  <div class="form-borrow">
    <div class="row">
      <div class="col-md-12 text-center">
        <p
          class="label-title-loan display-amount-container"
          style="font-size: 32px; color: var(--primary)"
        >
          <img
            alt=""
            src="img/icons/statement_black.svg"
            style="width: 45px"
          > PayDay <span
            style="color: var(--secondary)"
          >Loans</span>
        </p>
      </div>
      <div class="col-md-12 text-center display-amount-container mt-md-5">
        {{ $t('label.youNeed', {count: amountSlider}) }}
      </div>
      <div class="col-md-12 text-center">
        <slider
          v-model="amountSlider"
          :slider-interval="loanModel.amount.interval"
          :slider-max="loanModel.amount.max"
          :slider-min="loanModel.amount.min"
          :slider-warn="loanModel.amount.warn"
          label="label.var.usd"
          @onWarn="(value) => {warningAmount = value}"
        />
      </div>
      <div class="col-md-12 warning-container">
        <div
          :class="warningAmount ? 'show' : ''"
          class="text-center"
        >
          {{ $t('warning.onlyForSecondBorrower') }}
        </div>
      </div>
      <div class="col-md-12 text-center display-amount-container">
        {{ $t('label.youBorrowForDays', {count: amountDuration}) }}
      </div>
      <div class="col-md-12 text-center">
        <slider
          v-model="amountDuration"
          :slider-interval="loanModel.duration.interval"
          :slider-max="loanModel.duration.max"
          :slider-min="loanModel.duration.min"
          :slider-warn="loanModel.duration.warn"
          label="label.var.day"
        />
      </div>
      <div class="col-md-12 text-center payment-container">
        <div class="row">
          <div class="col-md-12 payment-label">
            {{ $t('label.paymentAmount') }}
          </div>
          <div class="col-md-12 payment-amount">
            USD {{ calculateAmountSliderModel.toFixed(2) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Slider from '../../components/Slider'

export default {
  name: 'PaydayCalculator',
  components: { Slider },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    loanModel: {
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    amountSlider: {
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    amountDuration: {
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    interestRates: {
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    warningAmount: {
      default: false
    }
  },
  data () {
    return {
      currentAmount: 0,
      currentDuration: 0
    }
  },
  computed: {
    calculateAmountSliderModel () {
      const unRoundedAmount = this.amountSlider * ((1 + this.interestRate * (this.amountDuration / 30)))
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentAmount = this.amountSlider
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentDuration = this.amountDuration
      return Math.ceil(unRoundedAmount)
    },

    interestRate () {
      const result = (process.env.VUE_APP_INTEREST_RATE / 100)
      if (this.interestRates !== null && this.interestRates.length > 0) {
        const rate = this.interestRates
        const tempResult = rate.filter((item) => {
          const satisfiedAmount = this.amountSlider >= item.start_amount && this.amountSlider <= item.end_amount
          const satifiedDay = this.amountDuration >= item.start && this.amountDuration <= item.end
          const defaultDay = item.start === 0 && item.end === 0
          return satisfiedAmount && (satifiedDay || defaultDay)
        })

        if (tempResult.length === 0) {
          const half = (this.loanModel.amount.min + this.loanModel.amount.max) / 2
          if (this.amountSlider > half) {
            return 8 / 100
          }
          return 15 / 100
        } else if (tempResult.length === 1) {
          return parseFloat(tempResult[0].percentage) / 100
        } else {
          const res = tempResult.filter((item) => {
            return !(item.start === 0 && item.end === 0)
          })[0]
          return parseFloat(res.percentage) / 100
        }
      }
      return result
    }
  }
}
</script>

<style scoped>
.warning-container {
  text-align: center;
}

.warning-container > div {
  margin-top: 10px;
  padding: 5px 15px;
  border-radius: 20px;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  font-weight: lighter;
  color: white;
  background-color: var(--dark-yellow);
  transition: 200ms;
  opacity: 0;
}

.warning-container > div.show {
  opacity: 1;
}

.display-amount-container {
  margin: 15px 0;
}

.payment-amount {
  font-weight: bold;
  font-size: 1.5em;
}
</style>
